import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { Comments } from "@common/interfaces/comment";
import { Topics } from "@common/interfaces/topics";
import { ID } from '@common/interfaces/id';
import { EntityState, EntityStore } from "@datorama/akita";

export interface CommentState extends EntityState<Comments, ID> { }

@Injectable({
    providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.ISSUE_COMMENTS , realtimeEntity: 'IssueComment'})
export class CommentStore extends EntityStore<CommentState> {
    constructor() {
        super([]);
    }
}
